import { gql } from "apollo-boost"

export const getCommentsf50 = gql`
query Commentsf50( $entities: [CommentEntitiesInputType!]!){
Commentsf50(entities: $entities) {
    id
    fieldName
    userRol
    User
    createdAt
    reviewed
    revision
    comment
    type
    consultant
    parentCommentId
    }
  }
`